import React from 'react';
import InstallButton from './InstallButton';

export default function InstallLink(props) {
    return <InstallButton tag="a" href="#" {...props} />;
}
